module.exports = __webpack_public_path__ + "img/arrowWhite.2ac2a532.svg";